import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { flags, useFeatureFlags } from 'lib/feature-flags'

const PgaHopeCardNote = () => {
  const [isEnabled] = useFeatureFlags([flags.FLAG_FEAT_PGA_HOPE_GRADUATE_CARD])
  if (!isEnabled) return null

  return (
    <Box textAlign="center" px={2} pt={3}>
      <Typography variant="body1">
        When you graduate, your digital PGA HOPE card appears under Accounts in
        MyPGA.
      </Typography>
    </Box>
  )
}

export default PgaHopeCardNote
